export enum TooltipTypes {
  OperationFinancialVariation = 'OperationFinancialVariation',
  InstrumentFinancialVariation = 'InstrumentFinancialVariation',
  TotalEarnings = 'TotalEarnings'
}
